module.exports = __webpack_public_path__ + "static/media/ex-decentralized-img1.ad93013b.svg";